import { ReactNode } from "react";
import { Categories, FreeSpinMode, Symbols } from "./type";
import BigNumber from "bignumber.js";
import Utils from "../../utils";
import { MatchedLine } from "../../type";

const DearSenpaiUtils = {
  isBuyingFreeSpin(category: Categories): boolean {
    return category === Categories.BuyFreeSpin;
  },
  takeSymbol(reelMatrix: number[][], x: number, y: number): number {
    return reelMatrix[x][y];
  },
  getStackWild(mode: FreeSpinMode, key?: string): ReactNode {
    if (mode === FreeSpinMode.Male)
      return <img key={key} alt="Wild" src="/ds/21_big_b.png" />;
    if (mode === FreeSpinMode.Female)
      return <img key={key} alt="Wild" src="/ds/21_big_g.png" />;
    return <img key={key} alt="Wild" src="/ds/21_big.png" />;
  },
  convertSymbol(symbol: number, mode: FreeSpinMode, key?: string): ReactNode {
    if (Number.isNaN(symbol)) return "";
    switch (symbol) {
      case Symbols.Symbol1:
        return mode === FreeSpinMode.Male ? (
          <img key={key} alt="Symbol 1" src="/ds/201_b.png" />
        ) : (
          <img key={key} alt="Symbol 1" src="/ds/201_g.png" />
        );
      case Symbols.Symbol2:
        return mode === FreeSpinMode.Female ? (
          <img key={key} alt="Symbol 2" src="/ds/202_g.png" />
        ) : (
          <img key={key} alt="Symbol 2" src="/ds/202_b.png" />
        );
      case Symbols.Symbol3:
        return mode === FreeSpinMode.Female ? (
          <img key={key} alt="Symbol 3" src="/ds/203_g.png" />
        ) : (
          <img key={key} alt="Symbol 3" src="/ds/203_b.png" />
        );
      case Symbols.Symbol4:
        return mode === FreeSpinMode.Male ? (
          <img key={key} alt="Symbol 4" src="/ds/204_b.png" />
        ) : (
          <img key={key} alt="Symbol 4" src="/ds/204_g.png" />
        );
      case Symbols.Symbol5:
        return <img key={key} alt="Symbol 5" src="/ds/205.png" />;
      case Symbols.Symbol6:
        return <img key={key} alt="Symbol 6" src="/ds/206.png" />;
      case Symbols.Symbol7:
        return <img key={key} alt="Symbol 7" src="/ds/207.png" />;
      case Symbols.Wild:
        if (mode === FreeSpinMode.Male)
          return <img key={key} alt="Wild" src="/ds/21_b.png" />;
        if (mode === FreeSpinMode.Female)
          return <img key={key} alt="Wild" src="/ds/21_g.png" />;
        return <img key={key} alt="Wild" src="/ds/21.png" />;
      case Symbols.Scatter:
        return <img key={key} alt="Scatter" src="/ds/25.png" />;
      case 0:
        return <></>;
      default:
        return symbol;
    }
  },
  symbolPayout(symbol: Symbols): number {
    const payouts = {
      [Symbols.Symbol1]: 50,
      [Symbols.Symbol2]: 25,
      [Symbols.Symbol3]: 15,
      [Symbols.Symbol4]: 10,
      [Symbols.Symbol5]: 5,
      [Symbols.Symbol6]: 3,
      [Symbols.Symbol7]: 2,
      [Symbols.Wild]: 100,
      [Symbols.Scatter]: 0, // Scatter does not have payout
    };
    return payouts[symbol] || 0;
  },
  takePayline(lineId: number): number[] {
    const LINE_PATTERNS = [
      [], // start from 1
      [1, 1, 1],
      [0, 0, 0],
      [2, 2, 2],
      [0, 1, 2],
      [2, 1, 0],
    ];

    return LINE_PATTERNS[lineId];
  },
  convertLine(
    reelMatrix: number[][],
    lineId: number,
    line: MatchedLine
  ): {
    lineDraw: ReactNode;
    symbolId: number;
  } {
    const maxY = reelMatrix[0].length;
    const symbolId =
      line.points
        .map((point) => reelMatrix[point.x][point.y])
        .find((symbol) => symbol !== Symbols.Wild) || 0;
    return {
      lineDraw: Utils.drawLine(maxY, this.takePayline(lineId)),
      symbolId,
    };
  },
  maxBetFormular(amount: number | BigNumber): BigNumber {
    return BigNumber(amount).multipliedBy(50); // buy free spin rate
  },
  maxPayoutFormular(amount: number | BigNumber): BigNumber {
    return BigNumber(amount)
      .multipliedBy(0.2) // bet size
      .multipliedBy(5) // 5 lines
      .multipliedBy(20) // free spin multiplier
      .multipliedBy(100); // max symbol payout
  },
} as const;

export default DearSenpaiUtils;
